import { render } from "./SkillIcon.vue?vue&type=template&id=0f0da058&scoped=true"
import script from "./SkillIcon.vue?vue&type=script&lang=js"
export * from "./SkillIcon.vue?vue&type=script&lang=js"

import "./SkillIcon.vue?vue&type=style&index=0&id=0f0da058&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Marti\\Desktop\\Web Development\\portfolio-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0da058"]])

export default __exports__